<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <v-card class="pa-5">
          <div>
            <h2 CLASS="text--primary text-uppercase">{{$t('Forget Password')}}</h2>
            <p class="caption">{{$t('Please enter your email to get reset code')}}</p>
          </div>
          <v-card-text class="pa-0">
            <v-form ref="loginForm">
              <v-text-field
                outlined
                v-model="userObj.email"
                :rules="[v=> !!v || $t('Email is required')]"
                :placeholder="$t('Email *')"
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="d-block text-center">
            <v-btn :loading="loader"  width="150" @click="login" elevation="0" color="primary">{{$t('Send')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        dobMenu: false,
        userObj: {
          email: '',
          lang: '',
        },
        loader: false
      }
    },
    methods: {
      login () {

        if (this.$refs.loginForm.validate()) {
          this.loader = true
          this.userObj.lang = this.$i18n.locale
          this.$http_sys_no_auth.post('Authentication/RequestResetPassword',this.userObj)
            .then(response=>{
              this.$router.push({ path: 'validate-password', query: { email: this.userObj.email } })
              this.loader = false
            })
            .catch(error=>{
              this.loader = false
              this.$store.dispatch('setSnackBarMessage',error.response.data.errorMessage)
            })
        }
      },
      saveDob (date) {
        this.$refs.dobMenu.save(date)
      },
    },
    watch: {
      dobMenu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    }
  }
</script>
<style>

</style>
